const ITEMS_EXPAND = 'product,reviews,publisher,sales-active';
const ITEMS_PER_PAGE = 20;

export const getListBaseUrl = (organizationId?: string) =>
  organizationId ? `/api/organizations/${organizationId}/lists` : '/api/lists';

export const getListUrl = (listId: string, organizationId?: string) =>
  `${getListBaseUrl(organizationId)}/${listId}`;

export const getListItemsUrl = (
  listId: string,
  organizationId?: string,
  page: number = 0
) => {
  const start = page * ITEMS_PER_PAGE;
  return `${getListUrl(listId, organizationId)}/items?expand=${ITEMS_EXPAND}&start=${start}&count=${ITEMS_PER_PAGE}`;
};
